import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

//route
export const purchaseRoute = createRoute({
    path: "/purchase",
    name: "menu.purchase",
    icon: "shopping_bag",
    accCode: "pembelian",
    exclude_breadcrumbs: true,
});

export const purchPORoute = createRoute({
    path: `${purchaseRoute.path}/po`,
    name: "purch_po.",
    code: 'PO',
    accCode: "pembelian_purchase_order_keluar",
    parentCode: purchaseRoute.accCode,
});

export const purchPOViewRoute = createRoute({
    path: `${purchPORoute.path}/view`,
    name: "purch_po.po_detail",
    code: 'PO',
    accCode: "pembelian_purchase_order_keluar",
    parentCode: purchaseRoute.accCode,
});

export const purchPOCreateRoute = createRoute({
    path: `${purchPORoute.path}/create`,
    name: "purch_po.create",
    code: 'PO',
    accCode: "pembelian_purchase_order_keluar",
    parentCode: purchaseRoute.accCode,
    action: "create",
    redirectTo: purchPORoute.path,
});

export const purchPOEditRoute = createRoute({
    path: `${purchPORoute.path}/edit`,
    name: "purch_po.edit",
    code: 'PO',
    accCode: "pembelian_purchase_order_keluar",
    parentCode: purchaseRoute.accCode,
    action: "edit",
    redirectTo: purchPORoute.path,
});

export const purchDOInCreateRoute = createRoute({
    path: `${purchPORoute.path}/do/create`,
    name: "purch_po.do",
    code: 'PO',
    accCode: "pembelian_purchase_order_keluar",
    parentCode: purchaseRoute.accCode,
    action: "create",
    redirectTo: purchPORoute.path,
});

export const purchQuotationRoute = createRoute({
    path: `${purchaseRoute.path}/quotation`,
    name: "purch_quotation.",
    code: 'QP',
    accCode: "pembelian_permintaan_penawaran",
    parentCode: purchaseRoute.accCode,
});

export const purchQuotationCreateRoute = createRoute({
    path: `${purchQuotationRoute.path}/create`,
    name: "purch_quotation.add",
    code: 'QP',
    accCode: "pembelian_permintaan_penawaran",
    parentCode: purchaseRoute.accCode,
    action: "create",
    redirectTo: purchQuotationRoute.path,
});

export const purchQuotationViewRoute = createRoute({
    path: `${purchQuotationRoute.path}/view`,
    name: "purch_quotation.detail",
    code: 'QP',
    accCode: "pembelian_permintaan_penawaran",
    parentCode: purchaseRoute.accCode,
});

export const purchInvoiceRoute = createRoute({
    path: `${purchaseRoute.path}/invoice`,
    name: "purch_invoice.",
    code: 'INVP',
    accCode: "pembelian_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
});

export const purchInvoiceViewRoute = createRoute({
    path: `${purchInvoiceRoute.path}/view`,
    name: "purch_invoice.detail",
    code: 'INVP',
    accCode: "pembelian_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
});

export const purchInvoiceCreateRoute = createRoute({
    path: `${purchInvoiceRoute.path}/create`,
    name: "purch_invoice.add",
    code: 'INVP',
    accCode: "pembelian_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
    action: "create",
    redirectTo: purchInvoiceRoute.path,
});

export const purchInvoiceEditRoute = createRoute({
    path: `${purchInvoiceRoute.path}/edit`,
    name: "purch_invoice.edit",
    code: 'INVP',
    accCode: "pembelian_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
    action: "edit",
    redirectTo: purchInvoiceRoute.path,
});

export const purchItemInRoute = createRoute({
    path: `${purchaseRoute.path}/doin`,
    name: "whs_itemin.",
    code: 'DOIN',
    accCode: "pembelian_barang_masuk",
    parentCode: purchaseRoute.accCode,
});

export const purchItemInViewRoute = createRoute({
    path: `${purchItemInRoute.path}/view`,
    name: "whs_itemin.detail",
    code: 'DOIN',
    accCode: "pembelian_barang_masuk",
    parentCode: purchaseRoute.accCode,
});

export const purchReturnSupRoute = createRoute({
    path: `${purchaseRoute.path}/returnSupplier`,
    name: "purch_returnsupplier.",
    code: 'RSP',
    accCode: "pembelian_retur_pemasok",
    parentCode: purchaseRoute.accCode,
});

export const purchInvRecapRoute = createRoute({
    path: `${purchaseRoute.path}/recap`,
    name: "purch_recap.",
    code: 'RINV',
    accCode: "pembelian_rekap_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
});

export const purchInvRecapCreateRoute = createRoute({
    path: `${purchInvRecapRoute.path}/create`,
    name: "purch_recap.add",
    code: 'RINV',
    accCode: "pembelian_rekap_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
    action: "create",
    redirectTo: purchInvRecapRoute.path,
});

export const purchInvRecapViewRoute = createRoute({
    path: `${purchInvRecapRoute.path}/view`,
    name: "purch_recap.detail",
    code: 'RINV',
    accCode: "pembelian_rekap_tagihan_pembelian",
    parentCode: purchaseRoute.accCode,
});

// component
const Purchase = lazy(() => import("../page/purchase/Purchase"));
const PurchPO = lazy(() => import("../page/purchase/po/PO"));
const PurchPOView = lazy(() => import("../page/purchase/po/view/POView"));
const PurchPOFromMain = lazy(() => import("../page/purchase/POFormMain"));
const PurchDOInForm = lazy(() => import("../page/purchase/po/form_do_in/DOInForm"));

const PurchRefItemIn = lazy(() => import("../page/purchase/ref_item_in/PurchaseRefItemIn"));
const PurchRefItemInView = lazy(() => import("../page/purchase/ref_item_in/view/PurchaseRefItemInView"));

const PurchQuotation = lazy(() => import("../page/purchase/quotation/PurchaseQuotation"));
const PurchQuotationMain = lazy(() => import("../page/purchase/QuotationFormMain"));

const PurchInvoice = lazy(() => import("../page/purchase/invoice/PurchaseInvoice"));
const PurchInvoiceView = lazy(() => import("../page/purchase/invoice/view/PurchaseInvoiceView"));
const PurchInvoiceForm = lazy(() => import("../page/purchase/invoice/form/PurchaseInvoiceForm"));

const PurchReturSup = lazy(() => import("../page/purchase/return_supplier/PurchReturnSupplier"));

const PurchRecapInv = lazy(() => import("../page/purchase/recap/PurchInvRecap"));
const PurchRecapInvForm = lazy(() => import("../page/purchase/recap/form/PurchInvRecapForm"));
const PurchRecapInvView = lazy(() => import("../page/purchase/recap/view/PurchInvRecapView"));

export const purchMainTabRoutes = [
    purchQuotationRoute,
    purchPORoute,
    purchInvoiceRoute,
    purchItemInRoute,
    purchReturnSupRoute,
    purchInvRecapRoute,
];
export const purchaseMutationRoutes = [
    purchQuotationCreateRoute, purchQuotationViewRoute,
    purchInvoiceCreateRoute, purchInvoiceEditRoute, purchInvoiceViewRoute,
    purchPOViewRoute, purchPOCreateRoute, purchPOEditRoute, purchDOInCreateRoute,
    purchItemInViewRoute,
    purchInvRecapCreateRoute, purchInvRecapViewRoute
];

export const purchaseRoutes = {
    element: <Purchase />,
    children: addHandleRoute([
        { ...purchQuotationRoute, element: <PurchQuotation /> },
        { ...purchQuotationViewRoute, element: <PurchQuotationMain type="view" /> },
        { ...purchQuotationCreateRoute, element: <PurchQuotationMain type="form" /> },
        { ...purchPORoute, element: <PurchPO /> },
        { ...purchPOViewRoute, element: <PurchPOView /> },
        { ...purchPOCreateRoute, element: <PurchPOFromMain /> },
        { ...purchPOEditRoute, element: <PurchPOFromMain /> },
        { ...purchInvoiceRoute, element: <PurchInvoice /> },
        { ...purchInvoiceCreateRoute, element: <PurchInvoiceForm /> },
        { ...purchInvoiceEditRoute, element: <PurchInvoiceForm /> },
        { ...purchInvoiceViewRoute, element: <PurchInvoiceView /> },
        { ...purchItemInRoute, element: <PurchRefItemIn /> },
        { ...purchItemInViewRoute, element: <PurchRefItemInView /> },
        { ...purchReturnSupRoute, element: <PurchReturSup /> },
        { ...purchDOInCreateRoute, element: <PurchDOInForm /> },
        { ...purchInvRecapRoute, element: <PurchRecapInv /> },
        { ...purchInvRecapCreateRoute, element: <PurchRecapInvForm /> },
        { ...purchInvRecapViewRoute, element: <PurchRecapInvView /> },
    ]),
};